import { fulfilled, pending, rejected } from '../../../utils';
import { REGISTER } from '../../actions/actiontype';

const initialState = {
    status: '',
    loading: false,
    message: '',
    error: '',
};

const registerReducer = (state = initialState, action) => {
    switch (action.type) {
        case pending(REGISTER):
            return {
                ...state,
                loading: true,
                message: '',
                error: '',
            };
        case fulfilled(REGISTER):
            return {
                ...state,
                loading: false,
                status: action.payload.data.status,
                message: action.payload.data.message,
                error: '',
            };
        case rejected(REGISTER):
            return {
                ...state,
                loading: false,
                message: '',
                error: action.payload.response.data.message,
            };
        default:
            return state;
    }
};

export default registerReducer;
